import { gql } from '@apollo/client';

export const GET_COMPANIES_FOR_USER = gql`
  query GetCompaniesForUser {
    getCompaniesForUser {
      id
      companyName
    }
  }
`;
